function NotFound() {
    return <div>404 - page Not Found</div>;
}

export default NotFound;